let counter = 0;
const prefix = Math.random().toString(36).substring(2);

/** generates a unique id by generating a random but constant identifier
 * and attaching an incrementing counter for every subsequent call */
export const generateUniqueId = (): string => `${prefix}-${counter++}`;
